import { Box, Typography } from '@mui/material';
import { GridRowId } from '@mui/x-data-grid-premium';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { TrackedLink as Link } from '../../../components/TrackedComponents';
import palette from '../../ColorPalette';

interface DashboardLinkProps {
    malfunctionId?: GridRowId;
}

const DashboardLink: React.FC<DashboardLinkProps> = (props) => {
    const history = useHistory();
    const { t } = useTranslation();

    return (
        <Box
            sx={{ width: '100%', display: 'flex', justifyContent: 'center', minHeight: 0, flexShrink: 0, mt: 1, mb: 3 }}
        >
            <Link
                id="back-to-dashboard-link"
                component="button"
                onClick={() =>
                    history.push(props.malfunctionId !== undefined ? `/tasks/${props.malfunctionId}` : '/tasks')
                }
            >
                <Typography fontSize={14} sx={{ color: palette.neutral[700] }}>
                    {t('setup_tool.back_to_dashboard')}
                </Typography>
            </Link>
        </Box>
    );
};

export default DashboardLink;
